export default __webpack_public_path__ + "8dffddc10a1c68c4bfa707be2acc8426.jpg";